import { Typography } from "@mui/material";
import { useFormat } from "@sinch/core/hooks/format";
import React, { FC } from "react";

/**
 * Renders a ratio as a percentage, styled the same way as {@link CurrencyCell} so it lines up with the
 * neighbouring rate columns. Nothing is rendered for a ratio that cannot be calculated.
 */
export const PercentageCell: FC<{
  value: number | null;
  isTotalRow: boolean;
}> = ({ value, isTotalRow }) => {
  const { num } = useFormat();

  if (value === null) {
    return null;
  }

  return (
    <Typography
      sx={({ typography, palette }) => {
        const negativeNoZero = value === 0 ? undefined : palette.error.main;
        return ({
        fontWeight: (isTotalRow ? typography.fontWeightBold : typography.fontWeightRegular) ?? null,
        color: value > 0 ? palette.success.main : negativeNoZero,
      });}}
    >
      {num.percent(value, { maximumFractionDigits: 1 })}
    </Typography>
  );
};
